export default __webpack_public_path__ + "8bd79ed43965039b794ca004e6a7f97d.svg";